export const NAV_ITEMS = [
  "Solutions",
  "Services",
  "Industries",
  "Projects",
  "About",
  "Insights",
  "Support",
  "Contact",
];

export const CAPABILITIES = [
  { title: "Software Services", text: "Custom software, web applications, ERP & CRM and integrations — built, debugged and maintained by our own team." },
  { title: "Integrated Security", text: "CCTV, access control, intrusion detection and video surveillance — designed as one shield." },
  { title: "Smart Infrastructure", text: "Networking, structured cabling, Wi-Fi, servers and data infrastructure built to grow." },
  { title: "Automation & Technology", text: "Smart office, automation, communication and digital solutions that run quietly in the background." },
  { title: "IT Products & Supply", text: "Computers, laptops, servers, networking, UPS, printers, peripherals, software and accessories — professionally supplied." },
];

export const SOLUTIONS = [
  { name: "IT Infrastructure", text: "Servers, storage, virtualization, backup and data infrastructure." },
  { name: "Network Infrastructure", text: "Enterprise switching, routing, firewalls, WAN and structured cabling." },
  { name: "Wi-Fi & Wireless", text: "Business and enterprise Wi-Fi with engineered coverage." },
  { name: "Security & Surveillance", text: "CCTV, IP surveillance, NVR/VMS and remote monitoring." },
  { name: "Access Control", text: "Biometric, RFID, visitor management, time and attendance." },
  { name: "Communication", text: "EPABX, IP-PBX, intercom and business telephony." },
  { name: "Smart Office", text: "Meeting-room technology, displays and workplace integration." },
  { name: "Automation", text: "Building, office and access automation with integrated control." },
  { name: "Power & Continuity", text: "UPS, power protection and infrastructure continuity." },
  { name: "Cloud & Digital Infrastructure", text: "Cloud, backup, remote and hybrid environments." },
  { name: "IT Products & Supply", text: "Computers, laptops, servers, printers, UPS, peripherals, software and accessories — supplied professionally for business." },
];

export const INDUSTRIES = [
  "Corporate & Offices",
  "Retail",
  "Hospitality",
  "Healthcare",
  "Education",
  "Residential Communities",
  "Commercial Buildings",
  "Small & Medium Businesses",
];

export const DISTRICTS = [
  "Kasaragod", "Kannur", "Wayanad", "Kozhikode", "Malappuram",
  "Palakkad", "Thrissur", "Ernakulam", "Idukki", "Kottayam",
  "Alappuzha", "Pathanamthitta", "Kollam", "Thiruvananthapuram",
];

export const CONTACT = {
  phone: "+91 484 457 0089",
  phone2: "+91 484 317 9289",
  whatsapp: "+91 9895 484 333",
  whatsappLink: `https://wa.me/919895484333?text=${encodeURIComponent("Hello NexSecure Technologies, I would like to discuss a requirement.")}`,
  telegramLink: "https://t.me/NexSecureSupportBot",
  mapsLink: "https://share.google/BJKZfhfddkXlwjCEf",
  hours: "Monday – Saturday, 9:30 AM – 5:30 PM IST",
  sales: "sales@nexsecure.in",
  info: "info@nexsecure.in",
  support: "support@nexsecure.in",
  addressLines: [
    "NexSecure Technologies,",
    "No. 64/1912, Arakkal Building,",
    "St. Francis Xavier's Road,",
    "Opposite Praxis Health Technologies,",
    "Kathrikadavu, Kaloor, Ernakulam,",
    "Kerala – 682017, India.",
  ],
};

export const SOLUTION_AREAS = [
  "Integrated Solutions",
  "Smart Infrastructure",
  "Automation",
  "IT Products & Supply",
  "Managed Services",
  "Software Services",
  "Other",
];

export const LOGO = {
  fullDark: "/assets/logo-full-dark.svg",
  fullLight: "/assets/logo-full-light.svg",
  iconDark: "/assets/logo-icon-dark.svg",
  iconLight: "/assets/logo-icon-light.svg",
  wordDark: "/assets/logo-word-dark.svg",
  nameDark: "/assets/logo-name-dark.svg",
  wordLight: "/assets/logo-word-light.svg",
  iconPan: "/assets/logo-icon-pan.svg",
  namePan: "/assets/logo-name-pan.svg",
  wordPan: "/assets/logo-word-pan.svg",
  iconBlue: "/assets/logo-icon-blue.svg",
  nameBlue: "/assets/logo-name-blue.svg",
  wordBlue: "/assets/logo-word-blue.svg",
  fullBlue: "/assets/logo-full-blue.svg",
};
